import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: ${ThemeColors.Bg2500};
  width: 100%;
  height: 100%;
  padding: 2rem;
  box-sizing: border-box;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
  height: 100%;
  width: 100%;
`;

export const ArtImage = styled.img`
  object-fit: cover;
  border-radius: 1.5rem;
  width: 100%;
  height: 30%;
`;

export const CTAContainer = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
`;
